import type { Device } from 'src/types/Device';
import { writable } from 'svelte/store';
export const edit = writable(false);
export const initialEdit = writable(false);
export const dashEdit = writable(false);
export const bulkActionEdit = writable(false);

export const reorder = writable(false);

export type UpdateModeTypes =
	| 'account_transfer_devices'
	| 'change'
	| 'update'
	| 'appliance_type'
	| 'exclude_event_log'
	| 'measure_peak_power'
	| 'consumption_calculation'
	| 'exclude_forgotten_lights'
	| 'offline_notifications'
	| 'ai_device_failure'
	| 'pin_lock'
	| 'bulk_move_devices_to_another_room'
	| 'bulk_delete'
	| 'apply_settings_configuration'
	| 'change_view';

export type UpdateModeSubTypes = 'enable_ai_model' | 'manage_ai_notifications' | 'disable_ai_model' | '';

export const update = writable<{
	value: boolean;
	type: UpdateModeTypes;
	subType: UpdateModeSubTypes;
	selectAll: boolean;
	selectedDevices: Device;
}>({
	value: false,
	type: 'update',
	subType: '',
	selectAll: false,
	selectedDevices: {} as Device,
});

export const resetEditUpdateStore = () => {
	edit.set(false);
	initialEdit.set(false);
	bulkActionEdit.set(false);
	update.update((s) => {
		return {
			...s,
			subType: '',
			value: false,
			selectAll: false,
			selectedDevices: {},
		};
	});
};
